<div class="wrapper">
    <div class="dashboard-row">
        <div class="dashboard-column">
            <div class="title-wrapper">
                <p class="font-weight-bold">
                    Datei Download
                </p>
            </div>
        </div>
    </div>
    <div class="dashboard-row">
        <div class="dashboard-column">
            <div class="dashboard-row">
                <app-file-download
                        title="Produkte"
                        fileName="Produkte.xlsx"
                        getPath="/api/products/export"
                        [isTrigger]="true"
                >
                </app-file-download>
                <app-file-download
                        title="Brillanten"
                        fileName="Brillanten.xlsx"
                        getPath="/api/brillants/export"
                >
                </app-file-download>
                <app-file-download
                        title="Werte"
                        fileName="Werte.xlsx"
                        getPath="/api/values/export"
                >
                </app-file-download>
            </div>
        </div>
    </div>
</div>
